<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'orders-suppliers-items-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
      </div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-info">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Fournisseur</th>
          <th scope="col">Date</th>
          <th scope="col">Montant Total</th>
          <th scope="col">Total Quantité</th>
          <th scope="col">Créer par</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, index) in orders" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ order.reference }}
          </td>
          <td>
            <span v-if="order.supplier">
              {{ order.supplier.society }}
              {{ order.supplier.society }}
            </span>
          </td>
          <td>{{ order.date }}</td>
          <td>
            <span v-if="order.totalPriceTTC != null" class="text-info">
              {{ order.totalPriceTTC }}
            </span>
            DH
          </td>
          <td>
            <span v-if="order.totalQuantity != null" class="text-warning">
              {{ order.totalQuantity }}
            </span>
          </td>

          <td>
            <span v-if="order.user">
              {{ order.user.name }}
            </span>
          </td>
          <td class="p-0 m-0">
            <button
              @click="
                $router.push({
                  name: 'orders-suppliers-details',
                  params: { reference: order.reference },
                })
              "
              class="btn"
            >
              <i class="bi bi-info-square fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("order", {
      orders: "getOrderSuppliers",
    }),
  },
  mounted() {
    this.$store.dispatch("order/getSupplierOrders");

    // setInterval(() => {
    //   this.$store.dispatch("order/getAll");
    // }, 3000);
  },
  methods: {
    async search(value) {
      return await this.$store.commit("order/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("order/getSupplierOrders");
    },
  },
};
</script>
